import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import UserMasterTable from './UserMasterTable'
import { connect } from 'react-redux'
import { updateModal } from '../../../../store/common/common_action';
import CreateNewUser from './CreateNewUser'
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { statusOpt } from "../constants"
import { deleteInactiveUsers, getAllBranchName, getAllDriverConductor, getRollRights } from '../../../../store/branchAndUserMaster/BUMAction'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'

const UserMaster = (props) => {
    const { data, getAllBranchName, getAllDriverConductor, getRollRights, deleteInactiveUsers, loginData } = props
    const { common } = data
    const [showTable, setShowTable] = useState(false)
    const [status, setStatus] = useState({ name: 'Active', id: 1 })
    const [branchData, setBranchData] = useState([])
    const [rollRightData, setRollRightData] = useState([])
    const [userDetailsList, setUserDetailsList] = useState([])
    const [tableData, setTableData] = useState([])
    const [selectedUserIds, setSelectedUserIds] = useState([])
    const [, setLoader] = useAtom(globalLoaderAtom)
    const [, setAlert] = useAtom(alertAtom)
    const [modal, setModal] = useAtom(modalAtom)
    useEffect(() => {
        focusElemnt("UMStatus")
    }, [])
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined') {
            getBranchData()
            getRollRightsData()
            if (loginData.intCompanyID) {
                onLoad()
            }
        }
    }, [loginData?.intCompanyID])
    const getBranchData = () => {
        const obj = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1,
        }
        getAllBranchName(obj, true, 24 * 60 * 60 * 1000).then((res) => {
            if (res?.status == 'Success') {
                if (res?.Data?.Table?.length > 0) {
                    setBranchData(res?.Data?.Table || [])
                } else {
                    setBranchData(res?.Data?.Table || [])
                }
            } else {
                setModal();
                setAlert({ show: true, msg: res.Message, nextId: 'GSBConsignment_Type' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const getRollRightsData = () => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            RoleID: 0,
            IsActive: 1,
        }
        getRollRights(obj, true, 24 * 60 * 60 * 1000).then((res) => {
            if (res?.status == 'Success') {
                if (res?.Data?.Table?.length > 0) {
                    setRollRightData(res?.Data?.Table || [])
                } else {
                    setRollRightData(res?.Data?.Table || [])
                }
            } else {
                setAlert({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const CreateNewUserModal = () => {
        return <CreateNewUser onLoad={onLoad} rollRightData={rollRightData} isEdit={false} branchData={branchData || []} loginData={loginData} />
    }
    const onLoad = async () => {
        setLoader(true)
        const body = {
            intUserID: 0,
            intCompanyID: loginData.intCompanyID,
            intBranchID: 0,
            strUserName: '',
            strLoginID: '',
            strPassword: '',
            strContactNo: '',
            intRoleID: 0,
            intIsActive: -1,
        }
        try {
            const res = await PostRequest(urls.getUserMasterTableData, body)
            if (res.status === 'Success') {
                const list = res?.Data?.Table || []
                setUserDetailsList(list)
                const filterList = list.filter((item) => status?.id === -1 || item?.IsActive === status?.id)
                setTableData(filterList)
                setSelectedUserIds([])
            } else {
                setAlert({ show: true, msg: res.ErrMessage })
            }
        } catch (error) {
            console.log('Error:', error)
        } finally {
            setLoader(false)
            setShowTable(true)
        }
    }
    const inactiveUserList = userDetailsList?.filter((item) => item?.IsActive === 0) || []
    const selectedInactiveUserList = inactiveUserList.filter((item) => selectedUserIds.includes(item?.UserID))

    const delInactiveUsers = (userList = []) => {
        if (userList.length === 0) {
            setAlert({ show: true, msg: 'No inactive user selected for delete.' })
            return
        }
        const userIds = userList
            .map((item) => item?.UserID)
            .filter((id) => id !== undefined && id !== null && id !== '')

        if (userIds.length === 0) {
            setAlert({ show: true, msg: 'No valid inactive user found for delete.' })
            return
        }
        const body = {
            intCompanyID: loginData?.intCompanyID || 0,
            intUserID: loginData?.intUserID || 0,
            strDelUserIDs: userIds.join('~'),
        }
        deleteInactiveUsers(body).then((res) => {
            if (res.status === 'Success') {
                setAlert({ show: true, msg: res?.ErrMessage || 'Inactive user deleted successfully.' })
                setSelectedUserIds([])
                onLoad()
            } else {
                setAlert({ show: true, msg: res?.ErrMessage || 'Unable to delete inactive users.' })
            }
        }).catch((error) => {
            console.log('Error:', error)
            setAlert({ show: true, msg: 'Something went wrong while deleting inactive users.' })
        })
    }

    const handleDeleteSelectedInactiveUsers = () => {
        delInactiveUsers(selectedInactiveUserList)
    }
    return (
        <>
            <Box sx={sx.reportFlex} className='reportButton'>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    {/* <DropDownOA
                        id="UMCompanyName"
                        label={'Company Name'}
                        width="100%"
                        // dataKey={`SubType`}
                        // idKey={`ConsignmentSubTypeID`}
                        nextId={"UMStatus"}
                        prevId={"UMCreateNewMaster"}
                    /> */}
                    <DropDownOA
                        id="UMCompanyName"
                        label={'Company Name'}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    {/* <DropDownOA
                        id="UMStatus"
                        label={'Status'}
                        width="100%"
                        nextId={"UMLoad"}
                        prevId={"UMCompanyName"}
                    /> */}
                    <DropDownOA
                        id={"UMStatus"}
                        defaultvalue={status?.name || ""}
                        data={[{ name: "Show All", id: -1 }, ...statusOpt] || []}
                        width="100%"
                        noCross={true}
                        searchPlaceholder={`Search Status`}
                        label={"Status"}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId={"UMLoad"}
                        prevId={"UMCreateNewMaster"}
                        onSelect={(value) => {
                            setStatus(value)
                            setShowTable(false)
                        }}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMCreateNewMaster", "UMStatus", () => { })}>
                    <Button id="UMLoad" variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={onLoad}
                    >
                        LOAD
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMStatus", "UMLoad", () => { })}>
                    <Button id="UMCreateNewMaster" variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => setModal("CreateNewUser")}>
                        CREATE NEW USER
                    </Button>
                </Item>
                {status?.id === 0 && <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button variant="outlined" id='UMDeleteSelectedInactiveUsers' sx={{ width: '100%' }} className="receiveitembtn" onClick={handleDeleteSelectedInactiveUsers}>
                        Delete
                    </Button>
                </Item>}
            </Box>
            <Box sx={sx.reportFlex}>
                {(showTable) && <UserMasterTable tableData={tableData} status={status} rollRightData={rollRightData} branchData={branchData || []} onLoad={onLoad} loginData={loginData} selectedUserIds={selectedUserIds} setSelectedUserIds={setSelectedUserIds} />}

            </Box>
            {modal === "CreateNewUser" && CreateNewUserModal()}
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, getAllBranchName, getAllDriverConductor, getRollRights, deleteInactiveUsers
}
export default connect(mapStateToProps, mapDispatchToProps)(UserMaster)
